import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  directCheckout?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  directCheckout = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (directCheckout) {
      window.open('https://www.betterbysteps.com/cart/44200242380893:1', '_blank');
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.02,
    backgroundColor: '#d4b479'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`w-full md:w-auto px-8 py-4 bg-[#c9a96e] text-[#0f0f23] text-lg md:text-xl font-bold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 ${className}`} data-id="element-189">
      {children}
    </motion.button>;
}